import type { FaireProductEntity } from "../../entity_types/product";

export const p_qgvz9qxyyf: FaireProductEntity = {
  token: "p_qgvz9qxyyf",
  type: "product",
  name: "Tequila Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/15afe3b4039bdea5abb9466f2af1f44851544a2a213525ab8ad61159c364c17a.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/93f911a14d7046a00cad83b94260a4f5e7e7cd379f116b45ff30e9986b3899e7.png",
    "https://cdn.faire.com/fastly/4c902cd952891fb303dfd0a7eab3105258d2478c3338b170581a4ed381af2fec.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:59.911Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
